@if (emojiId != null) {
  <div class="relative">
    <!-- Emoji Button / Page Icon -->
    <button
      type="button"
      class="absolute top-0 left-0 -translate-x-2 -translate-y-16 z-10 p-2"
      [class.cursor-pointer]="isEditable"
      [class.-translate-y-22]="adjustForCoverImage"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (click)="openPickerIfEditable()"
    >
      <!-- Eomji / Icon -->
      <div class="emoji-container" style="width: 72px; height: 72px">
        <img [src]="getEmojiSvgUrl(emojiId)" [alt]="emojiId" class="w-full h-full object-contain" />
      </div>
    </button>

    <!-- Emoji Picker-->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayScrollStrategy]="blockScrollStrategy"
      [cdkConnectedOverlayPanelClass]="['mobile-emoji-picker', 'desktop-emoji-picker']"
      backdropClass="cdk-overlay-transparent-backdrop"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="showEmojiPicker"
      [cdkConnectedOverlayHasBackdrop]="true"
      (backdropClick)="showEmojiPicker = false"
      (detach)="showEmojiPicker = false"
    >
      <div class="picker-wrapper">
        <emoji-mart
          [set]="'twitter'"
          [style]="{ width: '100vw', maxWidth: '400px' }"
          [emojiSize]="34"
          [totalFrequentLines]="2"
          [showPreview]="false"
          (emojiSelect)="setEmoji($event); showEmojiPicker = false"
        >
        </emoji-mart>
      </div>
    </ng-template>
  </div>
}
